import { Injectable, ElementRef } from '@angular/core';
import { HttpService } from "./http.service";
import { debug } from 'util';
import { UserDataStoreService } from './user-data-store.service';
import { MerchantReportDTViewModel } from '../models/merchant-report-dt-view-model';
import { ClientReportDTViewModel } from '../models/client-report-dt-view-model';
import { promise } from 'protractor';
import { CreateResult } from '../models/create-result';
import { TerminalReportDTViewModel } from '../models/terminal-report-dt-view-model';
import { MerchantGroupReportDTViewModel } from '../models/merchant-group-report-dt-view-model';
import { TutukaReportDTViewModel } from '../models/tutuka-report-dt-view-model';
import { BankTransactionData } from '../models/bank-transaction-data-view-model';
import { ParticipantViewModel } from '../models/participant-view-model';
import { UserViewModel } from '../models/user-view-model';
import { MerchantReportUserLinkDTViewModel } from '../models/merchant-report-user-link-dt-view-model';
import { TerminalReportUserLinkDTViewModel } from '../models/terminal-report-user-link-dt-view-model';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ExcelJson } from '../models/Excel-Json-model';
import { ReportClientParticipantLink } from '../models/report-client-participant-link';
import { CreditBalanceViewModel } from '../models/credit-balance-view-model';
import { CreditViewModel } from '../models/credit-view-model';


const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class CreditService {

  public count: number = 0;

  constructor(private _httpService: HttpService, private _userDataStore: UserDataStoreService) {
  }

  public async GetCreditBalance(pan: string): Promise<CreateResult> {
    
    const httpResult = await this._httpService.apiGet<CreateResult>(`credit/balance/${pan}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetBalance(pan: string): Promise<any> {

    const httpResult = await this._httpService.apiPost<any>(`Balance`, {
      "processingCode": "301000",
      "pan": pan, //"6037360004000404"
      "currencyCode": "710",
      "cardAcceptorTerminalID": "ZAA00002",
      "cardAcceptorIDCode": "000000971025001",
      "cardAcceptorNameLocation": "McDonalds     Johannesburg GPZA"
    }, { baseURL: 'http://localhost:9000' });
    if (httpResult && httpResult.body) {
      console.log(httpResult.body);
      return httpResult.body;
    }

    return null;
  }

}
